if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      clearTimeout(
        this.filterChangeTimeout
      );

      this.applyFiltersFetchAbortController
        ?.abort();

      window.removeEventListener(
        'popstate',
        this.historyChangeHandler
      );

      window.removeEventListener(
        'on:breakpoint-change',
        this.breakpointChangeHandler
      );

      document.removeEventListener(
        'collection-product-tabs:updated',
        this.collectionTabsUpdateHandler
      );

      this.filters?.removeEventListener(
        'click',
        this.boundFiltersClick
      );

      this.filters?.removeEventListener(
        'input',
        this.boundFilterChange
      );

      this.filters?.removeEventListener(
        'change',
        this.boundFilterChange
      );

      this.activeFilters?.removeEventListener(
        'click',
        this.boundActiveFiltersClick
      );

      this.desktopSortBy?.removeEventListener(
        'change',
        this.boundFilterChange
      );
    }

    init() {
      this.filteringEnabled =
        this.dataset.filtering === 'true';

      this.sortingEnabled =
        this.dataset.sorting === 'true';

      this.form =
        document.getElementById('facets');

      this.results =
        document.getElementById(
          'filter-results'
        );

      this.expanded = [];
      this.filterChangeTimeout = null;

      this.activeShortcutFilter = '';
      this.activeShortcutTitle = '';

      /**
       * 固定事件处理函数引用，防止 AJAX 更新后
       * 重复绑定相同事件。
       */
      this.boundFiltersClick =
        this.handleFiltersClick.bind(this);

      this.boundFilterChange =
        this.handleFilterChange.bind(this);

      this.boundActiveFiltersClick =
        this.handleActiveFiltersClick.bind(this);

      this.breakpointChangeHandler =
        this.handleBreakpointChange.bind(this);

      this.historyChangeHandler =
        this.handleHistoryChange.bind(this);

      this.collectionTabsUpdateHandler =
        this.handleCollectionTabsUpdate.bind(this);

      /**
       * 后面添加筛选结果缓存时使用。
       */
      this.filterResponseCache =
        new Map();

      this.handleBreakpointChange();


      this.addElements();
      this.addListeners();

      window.addEventListener(
        'popstate',
        this.historyChangeHandler
      );

      document.addEventListener(
        'collection-product-tabs:updated',
        this.collectionTabsUpdateHandler
      );
    }

    addElements() {
      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll('.js-drawer-sort-by');
        this.desktopSortBy = document.querySelector('.products-toolbar__sort');
      }
    }

    addListeners() {
      /**
       * Facets 内容会被 AJAX 替换，
       * 因此需要给新节点重新绑定。
       *
       * 先 remove 再 add，可以保证不会重复。
       */
      if (this.filteringEnabled) {
        if (this.filters) {
          this.filters.removeEventListener(
            'click',
            this.boundFiltersClick
          );

          this.filters.removeEventListener(
            'input',
            this.boundFilterChange
          );

          this.filters.removeEventListener(
            'change',
            this.boundFilterChange
          );

          this.filters.addEventListener(
            'click',
            this.boundFiltersClick
          );

          this.filters.addEventListener(
            'input',
            this.boundFilterChange
          );

          this.filters.addEventListener(
            'change',
            this.boundFilterChange
          );
        }

        if (this.activeFilters) {
          this.activeFilters.removeEventListener(
            'click',
            this.boundActiveFiltersClick
          );

          this.activeFilters.addEventListener(
            'click',
            this.boundActiveFiltersClick
          );
        }

        window.removeEventListener(
          'on:breakpoint-change',
          this.breakpointChangeHandler
        );

        window.addEventListener(
          'on:breakpoint-change',
          this.breakpointChangeHandler
        );
      }

      /**
       * PC Sort by 不会随 Facets HTML 替换，
       * 更需要避免重复绑定。
       */
      if (
        this.sortingEnabled &&
        this.desktopSortBy
      ) {
        this.desktopSortBy.removeEventListener(
          'change',
          this.boundFilterChange
        );

        this.desktopSortBy.addEventListener(
          'change',
          this.boundFilterChange
        );
      }
    }

    /**
     * Handles viewport breakpoint changes.
     */
    // handleBreakpointChange() {
    //   if (theme.mediaMatches.lg) {
    //     this.setAttribute('open', '');
    //     this.setAttribute('aria-hidden', 'false');
    //     this.removeAttribute('aria-modal');
    //     this.removeAttribute('role');
    //   } else {
    //     this.close();
    //     this.setAttribute('role', 'dialog');
    //     this.setAttribute('aria-modal', 'true');
    //     this.setAttribute('aria-hidden', 'true');
    //     this.hidden = false;
    //   }
    // }

    handleBreakpointChange() {
      this.close();
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.setAttribute('aria-hidden', 'true');
      this.hidden = false;
    }
    /**
     * 控制抽屉只显示指定筛选组。
     *
     * @param {string} paramName Shopify filter.param_name。
     * @param {string} title 抽屉标题。
     */
    /**
     * 显示指定筛选组。
     *
     * paramName 为空：显示完整筛选和移动端 Sort by。
     * paramName 有值：只显示对应筛选组并隐藏 Sort by。
     */
    showFilterGroup(paramName = '', title = '') {
      const filterGroups = [
        ...this.querySelectorAll(
          '.js-facet-filter-group'
        )
      ];

      if (!filterGroups.length) {
        console.warn(
          '[FacetFilters] No filter groups were found.'
        );

        return false;
      }

      const isShortcutMode = Boolean(paramName);
      let matchingGroup = null;

      filterGroups.forEach((group) => {
        const groupParam =
          group.dataset.filterParam || '';

        const shouldShow =
          !isShortcutMode ||
          groupParam === paramName;

        group.hidden = !shouldShow;

        if (isShortcutMode && shouldShow) {
          matchingGroup = group;

          const details = group.matches('details')
            ? group
            : group.querySelector('details');

          if (details) {
            details.open = true;
          }
        }
      });

      /**
       * 找不到对应筛选组时恢复完整筛选，
       * 防止出现空抽屉。
       */
      if (isShortcutMode && !matchingGroup) {
        filterGroups.forEach((group) => {
          group.hidden = false;
        });

        console.warn(
          `[FacetFilters] Filter group not found: ${paramName}`
        );

        return false;
      }

      this.activeShortcutFilter = paramName;
      this.activeShortcutTitle = title;

      /**
       * 快捷筛选模式隐藏 Active filters。
       */
      const activeFilters = this.querySelector(
        '.facets__active-filters'
      );

      if (activeFilters) {
        if (isShortcutMode) {
          activeFilters.hidden = true;
        } else {
          activeFilters.hidden =
            !activeFilters.querySelector(
              '.active-filter'
            );
        }
      }

      /**
       * 排序显示规则：
       *
       * PC：始终隐藏抽屉内的 Sort by。
       * M：总 Filter 显示，快捷筛选隐藏。
       */
      const mobileSort = this.querySelector(
        '.facets__mobile-sort'
      );

      const filterSort = this.querySelector(
        '#filter-sort'
      );

      const isDesktop = window.matchMedia(
        '(min-width: 1024px)'
      ).matches;

      const hideDrawerSort =
        isDesktop || isShortcutMode;

      if (mobileSort) {
        mobileSort.hidden = hideDrawerSort;
      }

      if (filterSort) {
        filterSort.hidden = hideDrawerSort;
      }

      /**
       * 修改抽屉标题。
       */
      const drawerTitle = this.querySelector(
        '#facets-title'
      );

      if (drawerTitle) {
        if (!drawerTitle.dataset.defaultTitle) {
          drawerTitle.dataset.defaultTitle =
            drawerTitle.textContent.trim();
        }

        drawerTitle.textContent =
          title ||
          drawerTitle.dataset.defaultTitle;
      }

      this.classList.toggle(
        'is-shortcut-filter',
        isShortcutMode
      );

      return true;
    }

    /**
     * 恢复完整筛选抽屉。
     */
    resetFilterGroups() {
      this.showFilterGroup('', '');
    }
    /**
     * Handles 'input' events on the filters and 'change' events on the sort by dropdown.
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      // Only allow price 'change' events
      if (evt.type === 'change' && !(evt.target.id?.includes('price-range') || evt.target.id?.includes('sort-by'))) return;

      // Dont reload when typing a price
      if (evt.target.id?.includes('price-range') && evt.constructor.name === 'InputEvent') return;

      const timeoutDelay =
        evt.target.id?.includes('price-range')
          ? 500
          : 250;

      clearTimeout(this.filterChangeTimeout);

      this.filterChangeTimeout = setTimeout(() => {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const emptyParams = [];

        if (this.sortingEnabled) {
          let currentSortBy = searchParams.get('sort_by');

          // Keep the mobile facets form sync'd with the desktop sort by dropdown
          if (evt.target.tagName === 'CUSTOM-SELECT') {
            this.mobileSortByOptions.forEach((option) => {
              option.checked = option.value === evt.detail.selectedValue;
              currentSortBy = evt.detail.selectedValue;
            });
          }

          // Set the 'sort_by' parameter.
          if (currentSortBy) {
            searchParams.set('sort_by', currentSortBy);
          } else {
            searchParams.delete('sort_by');
          }
        }

        // Get empty parameters.
        searchParams.forEach((value, key) => {
          if (!value) emptyParams.push(key);
        });

        // Remove empty parameters.
        emptyParams.forEach((key) => {
          searchParams.delete(key);
        });

        this.applyFilters(searchParams.toString(), evt);
      }, timeoutDelay);
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter 'clear' button clicked.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });

        if (!this.expanded.includes(filter.id)) {
          this.expanded.push(filter.id);
        }
      }
    }

    /**
     * Handles 'click' events on the active filters.
     * @param {object} evt - Event object.
     */
    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;
      evt.preventDefault();
      this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      const searchParams =
        evt.state?.searchParams ??
        window.location.search.replace(/^\?/, '');

      this.applyFilters(
        searchParams,
        null,
        false
      );
    }

    /**
     * Collection Tabs 切换后，让筛选请求使用当前分类 URL。
     */
    handleCollectionTabsUpdate(evt) {
      if (evt.detail?.append) return;

      const url = evt.detail?.url;
      if (!url) return;

      const collectionUrl = new URL(
        url,
        window.location.origin
      );

      collectionUrl.searchParams.delete('page');
      collectionUrl.searchParams.delete('section_id');

      this.collectionBaseUrl =
        collectionUrl.toString();

      /* 不同 Collection 的筛选结果不能共用旧缓存。 */
      this.filterResponseCache.clear();
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(searchParams, evt, updateUrl = true) {
      let closeBtn = null;
      let customPagination = null;
      let requestController = null;

      try {
        const activeElementId =
          document.activeElement?.id || '';

        customPagination =
          document.querySelector(
            'custom-pagination'
          );

        if (customPagination) {
          customPagination.dataset.pauseInfiniteScroll =
            'true';
        }

        this.results.classList.add('is-loading');
        this.results.setAttribute(
          'aria-busy',
          'true'
        );

        closeBtn = this.querySelector(
          '.js-close-drawer-mob'
        );

        if (closeBtn) {
          closeBtn.setAttribute(
            'aria-disabled',
            'true'
          );
          closeBtn.classList.add(
            'is-loading'
          );
        }

        /* 正常页面 URL，不包含 AJAX 专用参数。 */
        const pageUrl = new URL(
          this.collectionBaseUrl ||
            window.location.href
        );

        pageUrl.search = searchParams;
        pageUrl.searchParams.delete('page');
        pageUrl.searchParams.delete(
          'section_id'
        );

        /* Section Rendering 请求 URL。 */
        const requestUrl = new URL(
          pageUrl.toString()
        );

        const filterSectionId =
          this.form.dataset.filterSectionId ||
          this.results.dataset.productsSectionId;

        if (!filterSectionId) {
          throw new Error(
            'Missing filter section ID.'
          );
        }

        requestUrl.searchParams.set(
          'section_id',
          filterSectionId
        );

        const cacheKey =
          requestUrl.toString();

        if (this.applyFiltersFetchAbortController) {
          this.applyFiltersFetchAbortController.abort();
        }

        requestController =
          new AbortController();

        this.applyFiltersFetchAbortController =
          requestController;

        const fromCache =
          this.filterResponseCache.has(
            cacheKey
          );

        let responseHTML =
          this.filterResponseCache.get(
            cacheKey
          );

        if (!responseHTML) {
          const response = await fetch(
            requestUrl.toString(),
            {
              method: 'GET',
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest'
              },
              signal:
                requestController.signal
            }
          );

          if (!response.ok) {
            throw new Error(
              `Filter request failed: ${response.status}`
            );
          }

          responseHTML =
            await response.text();

          /* 限制缓存数量，避免长时间使用后无限增长。 */
          if (
            this.filterResponseCache.size >=
            30
          ) {
            const oldestKey =
              this.filterResponseCache
                .keys()
                .next().value;

            this.filterResponseCache.delete(
              oldestKey
            );
          }

          this.filterResponseCache.set(
            cacheKey,
            responseHTML
          );
        }

        const tmpl =
          document.createElement('template');

        tmpl.innerHTML = responseHTML;

        const nextFacets =
          tmpl.content.getElementById(
            'facets'
          );

        const nextResults =
          tmpl.content.getElementById(
            'filter-results'
          );

        if (!nextFacets || !nextResults) {
          /* 不缓存结构不完整的响应。 */
          this.filterResponseCache.delete(
            cacheKey
          );

          throw new Error(
            'Filter response is missing #facets or #filter-results.'
          );
        }

          // Restore UI state.
          this.form.querySelectorAll('details-disclosure > details').forEach((existingFilter) => {
            const target = tmpl.content.getElementById(existingFilter.id);
            if (target) {
              target.open = existingFilter.open;
            }
          });
          tmpl.content.querySelectorAll('#facets details-disclosure > details').forEach((newFilter) => {
            if (this.expanded.includes(newFilter.id)) {
              const hiddenElements = newFilter.querySelectorAll('.js-hidden');
              hiddenElements.forEach((listItem) => {
                listItem.classList.remove('js-hidden');
              });
              newFilter.querySelector('.filter__more')?.remove();
            }
          });

          // Update the filters.
          this.form.innerHTML = nextFacets.innerHTML;
          if (this.activeShortcutFilter) {
            this.showFilterGroup(
              this.activeShortcutFilter,
              this.activeShortcutTitle || ''
            );
          }

          // Preserve the CSS class of the results
          const currentResultsUl = this.results.querySelector('ul');
          this.currentResultsClass = currentResultsUl ? this.results.querySelector('ul').getAttribute('class') : this.currentResultsClass;

          // Update the results.
          this.results.innerHTML = nextResults.innerHTML;

          // Set the CSS class of the results to what it was
          const newResultsUl = this.results.querySelector('ul');
          if (newResultsUl && this.currentResultsClass) newResultsUl.setAttribute('class', this.currentResultsClass);

          // Reinitialize re-rendered components.
          this.addElements();
          this.addListeners();

          /* 初始化 AJAX 新插入商品的快速尺码。 */
          if (
            typeof window.initQuickSizeAreas ===
            'function'
          ) {
            window.initQuickSizeAreas(
              this.results
            );
          }

          // Reinitialize any custom pagination
          const updatedPagination =
            document.querySelector(
              'custom-pagination'
            );

          if (
            updatedPagination &&
            typeof updatedPagination.reload ===
              'function'
          ) {
            updatedPagination.reload();
          }

          // Update the URL.
          if (updateUrl) FacetFilters.updateURL(searchParams);

          // Scroll to the top of the results if needed
          if (this.results.getBoundingClientRect().top < 0) {
            // If the header is sticky, compensate for it when scrolling to elements
            let headerHeight = 0;
            if (document.querySelector('store-header[data-is-sticky="true"]')) {
              headerHeight = Number.parseInt(
                getComputedStyle(this.parentElement)
                  .getPropertyValue('--header-height')
                  .replace('px', ''),
                10
              ) || 0;
            }
            window.scrollTo({
              top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
              behavior: 'smooth'
            });
          }

          // Focus on the element with the same ID in the new HTML
          if (activeElementId) document.getElementById(activeElementId)?.focus();

          // Broadcast the update for anything else to hook into
          document.dispatchEvent(
            new CustomEvent(
              'on:facet-filters:updated',
              {
                bubbles: true,
                detail: {
                  searchParams,
                  results: this.results,
                  fromCache
                }
              }
            )
          );
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn(
            '[FacetFilters]',
            error
          );
        }
      } finally {
        /* 旧请求不得清除新请求的 loading 状态。 */
        if (
          requestController &&
          this.applyFiltersFetchAbortController !==
            requestController
        ) {
          return;
        }

        this.results?.classList.remove(
          'is-loading'
        );
        this.results?.removeAttribute(
          'aria-busy'
        );

        const currentCloseBtn =
          this.querySelector(
            '.js-close-drawer-mob'
          );

        currentCloseBtn?.classList.remove(
          'is-loading'
        );
        currentCloseBtn?.removeAttribute(
          'aria-disabled'
        );

        const currentPagination =
          document.querySelector(
            'custom-pagination'
          );

        if (currentPagination) {
          currentPagination.dataset.pauseInfiniteScroll =
            'false';
        }
      }
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
}